// extracted by mini-css-extract-plugin
module.exports = {"articleDate":"ArticleDate_articleDate__mAx1o"};